import React, { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useAtomValue } from 'jotai/react'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'

import { imageSchema } from '@/constants/schema'
// import { DEFAULT_AVATAR } from '@/constants/wallet'
import { useUpdateUserInfo } from '@/hooks/services/useUserInfo'
import useSolana from '@/lib/solana/hooks/useSolana'
import { copy } from '@/lib/utils'
import { services } from '@/stores'

import { Flex } from '../common/Box'
import { AsyncButton, Button, OutlineButton } from '../common/Button'
import { Input, Textarea } from '../common/Input'
import { Text } from '../common/Text'
// import { ImageUploader } from '../common/Uploader'
import { Copy } from '../svgr'
import { Form, FormControl, FormField, FormItem, FormMessage } from '../ui/form'

const FORM_SETTING = {
  maxName: 20,
  maxDesc: 300,
  maxFiles: 1,
  maxSize: 4 * 1024 * 1024 // 4MB
}

const ProfileForm: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { t } = useTranslation()
  const formSchema = z.object({
    name: z.string().trim().max(FORM_SETTING.maxName), // 字符串类型
    introduce: z.string().trim().max(FORM_SETTING.maxDesc), // 字符串类型
    file: imageSchema(
      t('common.imageError', { type: 'jpg|jpeg|png|gif', size: '4MB' })
    ).optional() // 可选的图片类型
  })
  const { address } = useSolana()
  const userInfo = useAtomValue(services.userInfoAtom)

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: userInfo?.uname || '',
      introduce: userInfo?.introduce || ''
    }
  })

  const { setParams: setUpdateParams, isLoading } = useUpdateUserInfo(() => {
    onClose()
    form.reset()
  })

  const handleCopy = useCallback(
    (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
      ev.preventDefault()
      ev.stopPropagation()
      if (!address) return
      copy(address)
    },
    [address]
  )

  const onSubmit = useCallback(
    (values: z.infer<typeof formSchema>) => {
      console.log('>>>>>> onSubmit: ', values)

      const formData = new FormData()

      formData.append('name', values.name)
      if (values.introduce) formData.append('introduce', values.introduce)
      if (values.file) formData.append('file', values.file)

      setUpdateParams(formData)
    },
    [setUpdateParams]
  )

  return (
    <Form {...form}>
      <form
        role="profile-form"
        onSubmit={form.handleSubmit(onSubmit, console.log)}
      >
        <div className="space-y-4">
          {/* <Flex className="items-center gap-2 xl:gap-4">
            <FormField
              control={form.control}
              name="file"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ImageUploader
                      single
                      name="profile-avatar"
                      defaultImage={userInfo?.photo || DEFAULT_AVATAR}
                      onChange={(file) => field.onChange(file)}
                      maxSize={FORM_SETTING.maxSize}
                      maxFiles={FORM_SETTING.maxFiles}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem className="flex-1">
                  <FormControl>
                    <Input
                      role="profile-name"
                      size="md"
                      maxLength={10}
                      {...field}
                      prefixNode={<Text className="text-xs xl:text-xl">@</Text>}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </Flex> */}
          <Input
            size="md"
            readOnly
            className="text-white"
            value={address}
            suffixNode={
              <Copy
                className="text-color-text-primary xl:size-4"
                onClick={handleCopy}
              />
            }
          />
          {/* <FormField
            control={form.control}
            name="introduce"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Textarea
                    role="profile-introduce"
                    {...field}
                    maxLength={300}
                    placeholder={t('profile.bio')}
                  />
                </FormControl>
              </FormItem>
            )}
          /> */}
          {userInfo?.xname && (
            <Input
              size="md"
              readOnly
              prefixNode={<Text variant="tertiary">Twitter</Text>}
            >
              <Flex className="items-center gap-1">
                <img src={userInfo.xavatar} className="size-6 rounded-full" />
                <Button size="xs" className="text-white" link>
                  <a href={`https://x.com/${userInfo.xname}`} target="_blank">
                    {userInfo ? `@${userInfo.xname}` : '--'}
                  </a>
                </Button>
              </Flex>
            </Input>
          )}
        </div>
        {/* <Flex className="mt-6 gap-3 font-Orbitron xl:mt-8 [&_button]:flex-1">
          <OutlineButton
            className="h-12"
            type="button"
            variant="secondary"
            onClick={onClose}
          >
            {t('common.close')}
          </OutlineButton>
          <AsyncButton
            role="profile-submit"
            type="submit"
            loading={isLoading}
            disabled={isLoading}
          >
            {t('common.save')}
          </AsyncButton>
        </Flex> */}
      </form>
    </Form>
  )
}

export default ProfileForm
